import { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

class InfoCard extends Component {
    constructor(props) {
        super(props);
        this.state = { generatingPdf: false };
    }

    dataUrlToBlob = (dataUrl) => {
        const [header, base64] = dataUrl.split(',');
        const mime = header.match(/:(.*?);/)[1];
        const binary = atob(base64);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
        return new Blob([bytes], { type: mime });
    };

    downloadPDF = async () => {
        this.setState({ generatingPdf: true });

        try {
            const allAreas = this.props.allAreas || [this.props.selectedArea];

            const areas = allAreas.map((area) => ({
                name: isNaN(area.name) ? area.name : `${area.type.split(' ')[0]} ${area.name}`,
                users: area.users || [],
            }));

            const mapImageDataUrl = await this.props.getImageMapaUrl();

            const formData = new FormData();
            formData.append('areas', JSON.stringify(areas));
            if (mapImageDataUrl) {
                formData.append('mapaImage', this.dataUrlToBlob(mapImageDataUrl), 'mapa.jpg');
            }

            const response = await axios.post(route('geo-referenciamento.print'), formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
                responseType: 'blob',
            });

            const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = 'georeferenciamento.pdf';
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(blobUrl);
        } catch (e) {
            console.error(e);

            let message = 'Erro ao gerar PDF. Tente novamente.';
            if (e.response?.data instanceof Blob) {
                try {
                    const text = await e.response.data.text();
                    message = JSON.parse(text)?.message || message;
                } catch (parseError) {
                    console.error(parseError);
                }
            }
            toast.error(message);
        }

        this.setState({ generatingPdf: false });
    };

    render() {
        const { type, selectedArea, showPdfButton } = this.props;

        const iconByType = {
            "Círculo": "fa-circle",
            "Círculo Manual": "fa-circle",
            "Polígono": "fa-draw-polygon",
            "Retângulo": "fa-square",
            "Empreendimento": "fa-building",
        };

        return (
            <div className="info-card area-info ov-hidden mt-mb-2">
                <hr className="info-card-hr hr-mapa" />

                {type.toLowerCase() != 'cidade' &&
                    <div className="info-card-header card-header">
                        <i className={`fa-solid ${iconByType[selectedArea.type] || ""}`} style={{ color: selectedArea.color }}></i>
                        {" "}{isNaN(selectedArea.name) ? selectedArea.name : `${type.split(' ')[0]} ${selectedArea.name}`}{" "}
                    </div>
                }

                <div className="card-body card-body-mapa-info">
                    <div className='font19'>
                        <span className="">Tipo da busca:</span> {selectedArea.type.toLowerCase()}
                    </div>

                    {selectedArea.radius !== undefined && (
                        <div className='font19'>
                            <span className="">Raio do círculo:</span> {Number(selectedArea.radius).toFixed(2)}
                        </div>
                    )}

                    <div className='font19'><span className="info-card-label">Total de usuários:</span> {selectedArea?.users?.length}</div>
                    <div className='font19'><span className="info-card-label">Total de empreendimentos:</span> {selectedArea?.buildings?.length}</div>

                    {showPdfButton && (
                        <button
                            className="btn-pdf-download"
                            onClick={this.downloadPDF}
                            disabled={this.state.generatingPdf}
                            style={{
                                marginTop: '8px',
                                backgroundColor: '#CF3C3E',
                                color: '#FFFFFF',
                                border: 'none',
                                borderRadius: '0',
                                padding: '8px 18px',
                                fontFamily: '"Archivo Expanded", Arial, sans-serif',
                                fontWeight: '600',
                                fontSize: '17px',
                                cursor: this.state.generatingPdf ? 'wait' : 'pointer',
                                opacity: this.state.generatingPdf ? 0.7 : 1,
                            }}
                        >
                            {this.state.generatingPdf ? 'Gerando...' : 'PDF'}
                        </button>
                    )}
                </div>
                <hr className="info-card-hr hr-mapa" />
            </div>
        );
    }
}

export default InfoCard;
